<template>
  <van-popup v-model="show" closeable :lazy-render="false">
    <div class="content">
      <div>
        <van-search v-model="searchCondition.name" placeholder="Search Image" left-icon="">
          <template #right-icon>
            <div class="icon" @click="search">
              <img src="@/assets/designMobile/searc-icon.png" alt="" style="width: 20px; height: 20px; line-height: 20px;"/>
            </div>
          </template>
        </van-search>
      </div>
      <div class="search">
        <select name="user" v-model="searchCondition.user_id">
          <option :value="val.id" v-for="val in userMap" :key="val.id">{{ val.name }}</option>
        </select>
        <img src="@/assets/designMobile/x.png" alt="" class="iconImg" />
      </div>
      <div class="searchTwo">
        <div class="is_system">
          <select v-model="searchCondition.is_system">
            <option :value="0">My</option>
            <option :value="1">System</option>
          </select>
          <img src="@/assets/designMobile/x.png" alt="" class="iconImg" />
        </div>
        <select
          name="myCategory"
          v-model="searchCondition.customer_category_id"
          @change="myCategoryFn"
          v-if="searchCondition.is_system == 0"
        >
          <option :value="+val.id" v-for="val in userCategoryTreeData" :key="val.id">{{ val.name }}</option>
        </select>
        <select name="systemCategory" :value="searchCondition.category_id" @change="systemCategoryFn" v-else>
          <option :value="val.id" v-for="val in systemCategoryTreeData" :key="val.id">{{ val.name }}</option>
        </select>
        <img src="@/assets/designMobile/x.png" alt="" class="iconImg" />
      </div>
      <div class="search">
        <van-divider />
      </div>
      <div class="imgBox">
        <div class="showImg" v-for="(value, index) in designImgList.data" :key="index" @click="changePodImg(value, 2)">
          <img :src="value.thumbnail_src" width="100%" height="100%" alt />
        </div>
      </div>
      <div class="pagination-wrap">
        <van-button class="prev" :disabled="searchCondition.page <= 1" @click="prevFn">
          <van-icon name="arrow-left" />
        </van-button>

        <span class="pagination-ct">
          <span>{{ searchCondition.page }}</span>
          /{{ Math.ceil(designImgList.total / 16) }}
        </span>
        <van-button class="next" :disabled="searchCondition.page === designImgList.last_page" @click="nextFn">
          <van-icon name="arrow" />
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { getDesignImgList } from '@/api/design'
import { getUserMap } from '@/api/orderAdmin'
import { getUserMaterialCategory, getMaterialCategory } from '@/api/openGallery'
export default {
  data() {
    return {
      show: false,
      designImgList: [],
      background: [],
      systemCategoryTreeData: [],
      userCategoryTreeData: [],
      userMap: [],
      customerData: {
        customer_category_id: 0
      },
      searchCondition: {
        name: '',
        page: 1,
        customer_category_id: 0,
        category_id: 0,
        total: 1,
        is_system: 0,
        per_page: 12,
        user_id: ''
      }
    }
  },
  props: ['selectPodImg'],
  methods: {
    search() {
      this.getDesignImgListMethod({ ...this.searchCondition, page: 1 })
    },
    myCategoryFn(e) {
      const options = e.target.options
      const index = e.target.selectedIndex
      this.searchCondition.customer_category_id = options[index].value
      this.getDesignImgListMethod({ ...this.searchCondition, page: 1 })
    },
    systemCategoryFn(e) {
      const options = e.target.options
      const index = e.target.selectedIndex
      this.searchCondition.category_id = options[index].value
      this.getDesignImgListMethod({ ...this.searchCondition, page: 1 })
    },
    changePodImg(value, type) {
      this.$emit('change', { id: value.id, code: value.code, src: value.show_image_src, type })
      this.show = false
    },
    getDesignImgListMethod(params) {
      getDesignImgList(params).then(res => {
        this.designImgList = res.data
        this.searchCondition.page = res.data.current_page
        this.searchCondition.total = res.data.total
      })
    },
    setMenuFn(arr) {
      arr.forEach(item => {
        item.id = `cate-${item.id}`
        if (item.children && item.children.length) {
          this.setMenuFn(item.children)
        }
      })
    },
    pushFn(arr) {
      for (let i = 0; i < arr.length; i++) {
        this.userCategoryTreeData.push(arr[i])
        if (arr[i].children.length > 0) {
          this.pushFn(arr[i].children)
        }
      }
    },
    getUserMaterialCategoryMethod(params) {
      getUserMaterialCategory(params).then(res => {
        this.userCategoryTreeData = []
        this.pushFn(res)
        console.log(this.userCategoryTreeData)
        this.userCategoryTreeData.unshift({ id: 0, name: 'Category' })
        this.searchCondition.customer_category_id = +this.userCategoryTreeData[0].id
      })
    },
    prevFn() {
      this.searchCondition.page--
      this.getDesignImgListMethod({ ...this.searchCondition })
    },
    nextFn() {
      this.searchCondition.page++
      this.getDesignImgListMethod({ ...this.searchCondition })
    }
  },
  watch: {
    'searchCondition.is_system'() {
      this.searchCondition.customer_category_id = 0
      this.searchCondition.category_id = 0
      this.getDesignImgListMethod({ ...this.searchCondition, page: 1 })
    },
    'searchCondition.user_id'() {
      this.getUserMaterialCategoryMethod({ user_id: this.searchCondition.user_id })
      this.getDesignImgListMethod({ ...this.searchCondition, page: 1 })
    }
  },
  created() {
    getMaterialCategory().then(res => {
      this.systemCategoryTreeData = res.data
      this.setMenuFn(this.systemCategoryTreeData)
      this.systemCategoryTreeData.unshift({ id: 0, name: 'Category' })
      this.searchCondition.category_id = +this.systemCategoryTreeData[0].id
    })
    getUserMap({ type: 3, is_arr: 1 }).then(res => {
      this.searchCondition.user_id = res.data[0].id
      this.userMap = res.data
    })
  }
}
</script>

<style scoped lang="less">
.content {
  padding: 25px 15px;
  width: 325px;
  font-size: 14px;
  color: #999999;
  .search,
  .searchTwo {
    position: relative;
    .iconImg {
      position: absolute;
      right: 30px;
      top: 15px;
      width: 12px;
      height: 8px;
    }
    padding: 0 14px;
    select {
      height: 34px;
      color: #999999 !important;
      width: 100%;
      border: 2px solid #f2f2f2 !important;
      height: 40px;
      -webkit-appearance: none;
      appearance: none;
      padding: 0px 10px;
      display: block;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      background-color: #ffffff;
    }
  }
  .searchTwo {
    margin: 10px 0;
    display: flex;
    .is_system {
      width: 184px;
      margin-right: 10px;
      position: relative;
      .iconImg {
        position: absolute;
        right: 10px;
        top: 15px;
        width: 12px;
        height: 8px;
      }
    }
  }
  .icon {
    display: flex;
    align-items: center;
  }
  img {
    width: 100%;
    height: 70px;
    line-height: 70px;
    box-sizing: border-box;
  }
  .imgBox {
    margin-bottom: 10px;
    padding: 0 14px;
    display: flex;
    flex-wrap: wrap;
    .showImg {
      margin-top: 10px;
      text-align: center;
      line-height: 70px;
      width: 30%;
      height: auto;
      background: #ffffff;
      box-shadow: 0px 4px 9px 0px rgba(44, 44, 44, 0.1);
      border-radius: 4px;
      margin-right: 3%;
      padding: 6px;
      box-sizing: border-box;
      &:nth-child(3n + 3) {
        margin-right: 0;
      }
    }
  }
  .pagination-wrap {
    float: right;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .pagination-ct {
      margin: 10px;
    }
    .prev,
    .next {
      width: 30px;
      height: 30px;
    }
  }
}
</style>
